// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"cd50794c9087565b022e","293":"e9c6cd677ee3d9c8161e","518":"f6e8f7c2d6fcd6ee2646","779":"3c436dcc163797272d3c"}[chunkId] + ".js";
};